import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSocial } from '../store/social';
import { usePalette } from '../theme';
import { Caption } from './ui';

export default function SocialError() {
  const { t } = useTranslation();
  const p = usePalette();
  const error = useSocial(s => s.error);
  const max = useSocial(s => s.overview?.maxMembers ?? 20);
  return error ? (
    <Caption color={p.danger}>{t(`social.errors.${error}` as 'social.errors.streak_full', { max })}</Caption>
  ) : null;
}
